import { Skeleton } from "@mui/material";
import SoftBox from "components/SoftBox";
import { generateData } from "utils/tableColumnData";

const data = (t) => {
  return {
    columns: [
      { name: t("table.pay_uno"), accessor: "source", align: "center" },
      { name: t("table.amount"), accessor: "from", align: "left" },
      { name: t("table.command"), accessor: "to", align: "left" },
      { name: t("table.req_acc"), accessor: "req_acc", align: "left" },
      { name: t("table.req_id"), accessor: "req_id", align: "left" },
      { name: t("table.fio"), accessor: "fio", align: "left" },
      { name: t("table.started_at"), accessor: "started At", align: "center" },
      { name: t("table.last_activity"), accessor: "last activity", align: "center" },
      { name: t("table.status"), accessor: "status", align: "right" },
      { name: t("table.actions"), accessor: "actions", align: "center" },
    ],
    skeletonRows: generateData(10, {
      [t("table.pay_uno")]: <Skeleton variant="text" sx={{ fontSize: "13px" }} width={70} />,
      [t("table.amount")]: <Skeleton variant="text" sx={{ fontSize: "13px" }} width={60} />,
      [t("table.command")]: <Skeleton variant="text" sx={{ fontSize: "13px" }} width={60} />,
      [t("table.req_acc")]: <Skeleton variant="text" sx={{ fontSize: "13px" }} width={60} />,
      [t("table.req_id")]: <Skeleton variant="text" sx={{ fontSize: "13px" }} width={60} />,
      [t("table.fio")]: <Skeleton variant="text" sx={{ fontSize: "13px" }} width={60} />,
      [t("table.status")]: <Skeleton variant="text" sx={{ fontSize: "13px" }} width={70} />,
      [t("table.started_at")]: <Skeleton variant="text" sx={{ fontSize: "13px" }} width={100} />,
      [t("table.last_activity")]: <Skeleton variant="text" sx={{ fontSize: "13px" }} width={100} />,
      [t("table.actions")]: (
        <SoftBox display="flex" alignItems="center" gap={1}>
          <Skeleton variant="text" sx={{ fontSize: "13px" }} width={70} />
          <Skeleton variant="text" sx={{ fontSize: "13px" }} width={70} />
        </SoftBox>
      ),
    }),
  };
};

export default data;